module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_6_3.61c1f998.jpeg";